import React from 'react';
import { DownloadIcon, BedIcon, HeartIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="bg-[#FDF8F0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#3D2E1F] mb-12 text-center" data-id="element-107">
          Cómo funciona
        </h2>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-8 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-[#B8A068] before:to-transparent" data-id="element-108">
          {/* Step 1 */}
          <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-109">
            <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-[#FDF8F0] bg-[#B8A068] text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-110">
              <DownloadIcon className="w-6 h-6" data-id="element-111" />
            </div>
            <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-xl shadow-md border border-[#F5EDE0]" data-id="element-112">
              <h3 className="font-bold text-[#3D2E1F] text-xl mb-2" data-id="element-113">
                1. Descarga el PDF
              </h3>
              <p className="text-[#3D2E1F] opacity-90 text-base md:text-lg" data-id="element-114">
                Recibe acceso inmediato en tu correo tras la compra.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-115">
            <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-[#FDF8F0] bg-[#B8A068] text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-116">
              <BedIcon className="w-6 h-6" data-id="element-117" />
            </div>
            <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-xl shadow-md border border-[#F5EDE0]" data-id="element-118">
              <h3 className="font-bold text-[#3D2E1F] text-xl mb-2" data-id="element-119">
                2. Aplícalo en la Cama
              </h3>
              <p className="text-[#3D2E1F] opacity-90 text-base md:text-lg" data-id="element-120">
                Realiza los 3 micro-movimientos antes de poner un pie en el
                suelo.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-121">
            <div className="flex items-center justify-center w-16 h-16 rounded-full border-4 border-[#FDF8F0] bg-[#B8A068] text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-122">
              <HeartIcon className="w-6 h-6" data-id="element-123" />
            </div>
            <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-xl shadow-md border border-[#F5EDE0]" data-id="element-124">
              <h3 className="font-bold text-[#3D2E1F] text-xl mb-2" data-id="element-125">
                3. Siente la Diferencia
              </h3>
              <p className="text-[#3D2E1F] opacity-90 text-base md:text-lg" data-id="element-126">
                Camina hacia el baño con pasos más fluidos y menos "crujidos"
                desde el primer día.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}